
import { Form, Button, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createProductReviewApi, editProductReviewApi } from "../../api/reviewsApi";
import { getStorageToken } from "../../utilities";

const initialForm = {
  title: "",
  comment: "",
  rating: 5,
}

export default function ReviewForm(props) {
  // form that allows users to submit a review

  const navigate = useNavigate();
  const {id, isAuthenticated, stayLoggedIn} = useSelector((state) => state?.user)
  
  const [formData, setFormData] = useState(props?.editReview || {...initialForm});

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();
      if(!isAuthenticated){
        props.setErrorMsg("Please login before leaving a review.")
      } else {
        const token = getStorageToken(stayLoggedIn);
        /// editing a review
        if(props?.editReview){
          await editProductReviewApi(token, formData);
          setFormData({...initialForm});
          props.setUpdateReviews(true);
          props.setSuccessMsg("Thank you! Your review has been created.")
          props.setEditReview(false);
        } else {
          /// creating a new review
          formData.user = id; 
          formData.productName = props?.productName;
          await createProductReviewApi(token, props.productId, formData);
          //api,...
          setFormData({...initialForm});
          props.setUpdateReviews(true);
          props.setSuccessMsg("Thank you! Your review has been created.")
        }
      }
    } catch(error){
      if (error?.status === 409) {  
        props.setErrorMsg("You can only review a product once. To modify your existing review, please visit your profile page.")
      } else {
        props.setErrorMsg("Could not submit review. Please try again later.")
      }
      
    }
  }

  const handleReviewLogin = () => {
    //navigate to login, after that navigate back to this product details page
    navigate(
      "/login",
      { state: { data: `/product-details/${props.productId}` } }
    )
  }
  return (
    <>
   
    {!isAuthenticated ?
       <Button style={{width: "fit-content" }} variant="link" onClick={handleReviewLogin}>Login to leave a review</Button>
    :
    <Row >
      <Col style={{backgroundColor: "#f6f6f6", borderRadius: "10px"}} xl={6}>
        <Form onSubmit={handleSubmit}>
          <Form.Label>
          </Form.Label>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Review Title</Form.Label>
            <Form.Control as="textarea" rows={1} maxLength={50} value={formData.title} required={true} onChange={(event) => setFormData({...formData, title: event.target.value})}/>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Your Review</Form.Label>
            <Form.Control as="textarea" rows={4} maxLength={600} value={formData.comment} required={true} onChange={(event) => setFormData({...formData, comment: event.target.value})}/>
          </Form.Group>

          <Form.Label>Overall Rating</Form.Label>
          <Form.Select size="md" aria-label="Default select example" value={formData.rating} required={true} onChange={(event) => setFormData({...formData, rating: Number(event.target.value)})}>
            <option value="5">5 (very good)</option>
            <option value="4">4 (good)</option>
            <option value="3">3 (average)</option>
            <option value="2">2 (bad)</option>
            <option value="1">1 (awful)</option>
          </Form.Select>
          <Button className="mt-3 mb-3" variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Col>
    </Row>}
    </>
  );
}
